function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnection = function SvgConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.452 13.613H3.788v3.238h2.664zm1.332 3.238c0 .716-.596 1.296-1.332 1.296H3.788c-.735 0-1.332-.58-1.332-1.296v-3.238c0-.715.597-1.295 1.332-1.295h2.664c.736 0 1.332.58 1.332 1.295zm6.66 0V7.784c0-.715-.596-1.295-1.332-1.295h-2.664c-.735 0-1.332.58-1.332 1.295v9.067c0 .716.597 1.296 1.332 1.296h2.664c.736 0 1.332-.58 1.332-1.296zm1.332 0c0 .716.597 1.296 1.332 1.296h2.664c.736 0 1.332-.58 1.332-1.296V1.307c0-.715-.596-1.295-1.332-1.295h-2.664c-.735 0-1.332.58-1.332 1.295zm-2.664-9.067h-2.664v9.067h2.664zm6.66-6.477h-2.664v15.544h2.664z",
    style: {
      strokeWidth: 0.875686
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "6.66667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      wordSpacing: 0
    },
    x: 1.222,
    y: 23.944
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.222,
    y: 23.944,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "6.66667px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    }
  }, "CONN")));
};
export default SvgConnection;